import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const UnidadeList = props => <DefaultDataTable data={props} />;
